﻿function init () {
  const openMenuButton = document.querySelector('.nav-btn__btn--open')
  const closeMenuButton = document.querySelector('.nav-btn__btn--close')
  const menu = document.querySelector('.header__menu')
  const overlay = document.querySelector('.header__menu-overlay')

  if (!openMenuButton) {
    return
  }

  openMenuButton.addEventListener('click', tooggleMenu)

  overlay.addEventListener('click', tooggleMenu)

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('header__menu--visible')) {
      tooggleMenu()
    }
  })

  function tooggleMenu () {
    menu.classList.toggle('header__menu--visible')
    overlay.classList.toggle('header__menu-overlay--visible')
    closeMenuButton.classList.toggle('nav-btn__btn--hidden')
    openMenuButton.classList.toggle('nav-btn__btn--hidden')
  }
}

export default init
